import { Component } from 'react';
import {connect} from 'react-redux';
import {getRDRNews} from '../../../actions/latest-news';
import NewsPage from '../../common/news-page/news-page';

class RdrNewsPage extends Component {
  pageSlug = 'rdr-news';

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getRDRNews());
  }

  render() {
    const {rdrNews, loading} = this.props;

    return loading ? <div>Loading...</div> : (
      <NewsPage
        title="RDR News"
        className={this.pageSlug}
        slug={this.pageSlug}
        articles={rdrNews}
        loading={loading}
      />
    );
  }
}

const mapStateToProps = state => ({
  rdrNews: state.latestNews.rdrNews,
  loading: state.latestNews.fetching && !state.latestNews.fetched,
});

export default connect(mapStateToProps)(RdrNewsPage);
